module.exports = __webpack_public_path__ + "static/img/avator_man.d3f90a5c.png";